<template>
  <div class="content">
    <div v-for="item in templateList" :key="item.id" class="templateList" @click="addAcivitys(item.id)">
      <img :src="item.picture" class="tem_img">
      <p>{{item.name}}</p>
      <div class="add_btn" @click="addAcivitys(item.id)">
        创建活动
      </div>
    </div>
    <div class="templateList" style="background:#E7E7E7">
      <img src="../../assets/images/expectMore.png" style="width: 68px;height: 68px;margin: 41px auto;">
      <p>期待更多</p>
    </div>
  </div>
</template>
<script>
import { getTemplate } from '@/api/activity.js'
export default {
  name: 'activeHome',
  data() {
    return {
      templateList: []
    }
  },
  methods: {
    getTemplate() {
      let data = {
        page: 1,
        limit: 10
      }
      getTemplate(data).then(res => {
        if (res.data.code === 0) {
          this.templateList = res.data.data.list
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    addAcivitys(id) {
      this.$router.push({path: 'add-activitys', query: { template_id: id }})
    }
  },
  created() {
    this.getTemplate()
  },
  components: {}
}

</script>
<style scoped>
  .content{
    min-height: 525px;
    background: #fff;
    margin: 24px;
    margin-bottom: 0;
  }
  .templateList{
    display: inline-block;
    width: 300px;
    height: 150px;
    float: left;
    margin: 20px;
    /*border: 1px solid #b3b0b0;*/
    background: #fff;
    /*border-radius: 5px;*/
    position: relative;
    cursor: pointer;
  }
  .templateList p{
    margin: 10px 0;
  }
  .templateList:hover .add_btn{
    display: block;
  }
  .tem_img{
    width: 100%;
    height: 100%;
  }
  .add_btn{
    position: absolute;
    bottom: 0;
    width: 100%;
    left: 0;
    background: rgba(5, 5, 5, 0.52);
    cursor: pointer;
    display: none;
    line-height: 40px;
    color: #fff;
  }
</style>
